jQuery(document).ready(function ($) {
  /* ==================== Fonts ==================== */

  const WebFont = require("webfontloader");

  WebFont.load({
    typekit: { id: 'qfu8nat' },
    /*google: {
      families: ["Poppins:300,400,600,700,900", ""],
    },*/
  });

  /* ==================== Menus ==================== */

  const mobileMenuToggle = document.querySelector(".navToggle"),
    mobileMenu = document.getElementById("mobileNav"),
    header = document.querySelector("#header"),
    subMenuItems = document.querySelectorAll(".menu-item-has-children"),
    mobileSubMenuItems = document.querySelectorAll(
      "#mobileNav .menu-item-has-children"
    ),
    adminBar = document.getElementById("wpadminbar");

  mobileSubMenuItems.forEach((element) => {
      element.addEventListener("click", toggleSubMenu);
  });

  function toggleSubMenu(event) {
    if (event.currentTarget === event.target || event.target.closest(".close-submenu")) {
      this.classList.toggle("active");
    }
  }

  //Accessibility for focus, open submenu
  mobileChildren = document.querySelectorAll(".sub-menu-wrap a");
  mobileChildren.forEach((element) => {
    element.addEventListener("focus", toggleSubMenu2);
    element.addEventListener("focusout", removeSubMenu2);
  });
  function toggleSubMenu2() {
    // Close any other open submenus
    document.querySelectorAll('.menu-item-has-children.active').forEach((item) => {
      if (item !== this.closest('.menu-item-has-children')) {
        item.classList.remove('active');
      }
    });
    this.closest('.menu-item-has-children').classList.add("active");
  }
  function removeSubMenu2(event) {
    // Check if focus is moving out of the submenu
    const menuItem = this.closest('.menu-item-has-children');
    if (!menuItem.contains(event.relatedTarget)) {
      menuItem.classList.remove("active");
    }
  }

  const setHeaderHeight = () => {
    let headerOffset = header.getBoundingClientRect().bottom;
    let adminBarHeight;
    if (adminBar) {
      adminBarHeight = adminBar.offsetHeight;
      header.style.top = `${adminBarHeight}px`;
    } else {
      adminBarHeight = 0;
    }
    if (headerOffset && adminBarHeight !== null) {
      mobileMenu.style.top = `${headerOffset}px`;
      mobileMenu.style.height = `calc(100vh - ${headerOffset}px)`;
    }
  };

  // Initialize header and mobile menu height
  setHeaderHeight();

  // Listen for window resizing to update header and mobile menu height as screen size changes
  addEventListener("resize", (event) => {
    setHeaderHeight();

    //Take mobile nav out of tabindex if not mobile and vice versa for desktop (on resize)
    if ($(window).width() > 991) {
      $('#mobileNav a').attr('tabindex','-1');
      $('#menu-main-menu a').removeAttr('tabindex');
    } else {
      $('#menu-main-menu a').attr('tabindex','-1');
      $('#mobileNav a').attr('tabindex','-1');
    }

  });

  mobileMenuToggle.addEventListener("click", () => {
    mobileMenuToggle.classList.toggle("is-active");
    mobileMenu.classList.toggle("menu-open");
    if  (mobileMenu.classList.contains("menu-open")) {
      $('#mobileNav a').removeAttr('tabindex');
    } else {
      $('#mobileNav a').attr('tabindex','-1');
    }
  });

  //Take mobile nav out of tabindex if not mobile and vice versa for desktop
  if ($(window).width() > 991) {
    $('#mobileNav a').attr('tabindex','-1');
    $('#menu-main-menu a').removeAttr('tabindex');
  } else {
    $('#menu-main-menu a').attr('tabindex','-1');
    $('#mobileNav a').attr('tabindex','-1');
  }

});

/* ==================== Scrolling Classes ==================== */

let scrollYPos = 0;

addEventListener("scroll", () => {
  //header.classList.toggle("sticky-header", window.scrollY > 0);
  if ($(window).width() > 991) {
    const y = window.scrollY;
    if (y > 50) {
      header.classList.add("scroll-header");
    } else if (y < 10) {
      header.classList.remove("scroll-header");
    }
  }
  header.classList.toggle("scroll-up", window.scrollY < scrollYPos);
  header.classList.toggle("scroll-down", window.scrollY > scrollYPos);
  scrollYPos = window.scrollY;

  // Home header changes
  const homeheader = document.querySelector(".home-header");
  const landingSection = document.querySelector(".home_landing_section");
  if (landingSection && homeheader) {
    const isVisible = landingSection.getBoundingClientRect().bottom > 0;
    homeheader.classList.toggle("banner-showing", isVisible);
  }

});

// Home header changes on load
const homeheader = document.querySelector(".home-header");
const landingSection = document.querySelector(".home_landing_section");
if (landingSection && homeheader) {
  const isVisible = landingSection.getBoundingClientRect().bottom > 0;
  homeheader.classList.toggle("banner-showing", isVisible);
}


//Hero Banner on load - autoplay iframe youtube or vimeo video
document.addEventListener("DOMContentLoaded", () => {
  const iframe = document.querySelector(".hero_banner iframe, .home_landing_section iframe");
  if (!iframe) return;

  let src = new URL(iframe.src);
  let videoID = src.searchParams.get("v"); // Extract YouTube video ID

  if (src.hostname.includes("youtube.com")) {
      src.search = `autoplay=1&controls=0&modestbranding=1&rel=0&loop=1&mute=1&playsinline=1`;
      if (videoID) src.search += `&playlist=${videoID}`; // Required for looping
  } 
  else if (src.hostname.includes("vimeo.com")) {
      src.search = "autoplay=1&background=1&loop=1&muted=1";
  }

  iframe.src = src.toString();
});

//Play video from play button
document.querySelectorAll(".play-button").forEach(button => {
  button.addEventListener("click", () => {
    const video = button.closest(".video-wrapper")?.querySelector("video");
    if (video) {
      video.play();
      button.style.display = "none";

      video.onpause = () => button.style.display = "block";
      video.onended = () => button.style.display = "block";
    }
  });
});


//Gallery Load More + Accessibility tabbing depending on open/closed state
$(document).on('click tap', '.galleryToggle', function (event) {
  if ($(this).attr('data-open') == 'false') {
    $(this).parent().find('.overflowImg').addClass('open');
    $(this).parent().find('.overflowImg a').attr('tabindex', '0');
    $(this).parent().find('.overflowImg a').attr('aria-hidden', 'false');
    $(this).attr('aria-hidden', 'false');
    $(this).attr('tabindex', '0');
    $(this).attr('data-open', 'true');
    $(this).find('span').text('Show less');
  } else {
    $(this).parent().find('.overflowImg').removeClass('open');
    $(this).attr('aria-hidden', 'true');
    $(this).attr('tabindex', '-1');
    $(this).attr('data-open', 'false');
    $(this).find('span').text('Show more');
  }
});

//Add click to tab when view videos button is clicked
if (document.getElementById('viewVideo') && document.querySelector('#tab-title-videos a')) {
  document.getElementById('viewVideo').addEventListener('click', function() {
    // Assuming 'additional_information' is the ID of the tab you want to open
    var tab = document.querySelector('#tab-title-videos a');
    
    if (tab) {
        tab.click();  // Trigger the click event of the tab link
    }
  });
}


//Testimonials Read More/Read Less functionality
function toggleReadMore() {
  document.querySelectorAll('.testimonials .swiper-slide').forEach(slide => {
    const content = slide.querySelector('.testimonial-content');
    const btn = slide.querySelector('.read-more-btn');

    if (!content || !btn) return;

    content.classList.remove('expanded');
    btn.style.display = 'none';

    if (content.scrollHeight > 250) {
      btn.style.display = 'inline-block';
      btn.textContent = 'Read More';
      btn.onclick = () => {
        content.classList.toggle('expanded');
        btn.textContent = content.classList.contains('expanded') ? 'Read Less' : 'Read More';
      };
    }
  });
}

setTimeout(toggleReadMore, 100);

window.addEventListener('resize', toggleReadMore);


function setSwiperSlideMinHeights() {
  document.querySelectorAll('.swiper-testimonials').forEach(container => {
    const slides = container.querySelectorAll('.swiper-slide');
    let maxHeight = 0;

    // Reset height
    slides.forEach(slide => {
      slide.style.minHeight = '0';
    });

    // Get tallest height including padding
    slides.forEach(slide => {
      const height = slide.getBoundingClientRect().height;
      if (height > maxHeight) maxHeight = height;
    });

    // Apply min-height
    slides.forEach(slide => {
      slide.style.minHeight = `${maxHeight}px`;
    });
  });
}
document.addEventListener('DOMContentLoaded', () => {
  setSwiperSlideMinHeights();
});
window.addEventListener('load', setSwiperSlideMinHeights);
window.addEventListener('resize', setSwiperSlideMinHeights);
